import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal"]
  static values = {
    open: Boolean
  }

  connect() {
    this.updateModal()
  }

  open() {
    this.openValue = true
    this.updateModal()
  }

  close() {
    this.openValue = false
    this.updateModal()
  }

  closeAfterSuccessfulSubmit(event) {
    if (!event.detail.success) return
    this.close()
  }

  openValueChanged() {
    this.updateModal()
  }

  updateModal() {
    if (!this.hasModalTarget) return

    const modal = this.modalTarget

    if (this.openValue) {
      if (typeof modal.showModal === "function") {
        modal.showModal()
      } else {
        modal.style.display = "block"
      }
    } else {
      if (typeof modal.close === "function") {
        modal.close()
      } else {
        modal.style.display = "none"
      }
    }
  }
}
